import { render, staticRenderFns } from "./WriteoffGift.vue?vue&type=template&id=03ed5be2&"
import script from "./WriteoffGift.vue?vue&type=script&lang=js&"
export * from "./WriteoffGift.vue?vue&type=script&lang=js&"
import style0 from "./WriteoffGift.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports